var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0202 13.6869C11.2155 13.4916 11.2155 13.1751 11.0202 12.9798L6.04046 8.00001L11.0202 3.02023C11.2155 2.82497 11.2155 2.50839 11.0202 2.31312C10.825 2.11786 10.5084 2.11786 10.3131 2.31312L4.9798 7.64646C4.88603 7.74023 4.83335 7.8674 4.83335 8.00001C4.83335 8.13262 4.88603 8.2598 4.9798 8.35356L10.3131 13.6869C10.5084 13.8822 10.825 13.8822 11.0202 13.6869Z",
    fill: "#0E46C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.58c80bcea1868baf950b52c6bdd54bdc.svg";
export { ForwardRef as ReactComponent };